import { braintree } from '../constants/actions'

const initialState = {
  paymentMethods: [],
}

export default (state = initialState, action) => {
  switch (action.type) {
    case braintree.SET_BT_PAYMENT_METHODS:
      return {
        ...state,
        paymentMethods: action.payload,
      }
    default:
      return state
  }
}
